import { render, staticRenderFns } from "./AddInsurance.vue?vue&type=template&id=01967b2c"
import script from "./AddInsurance.vue?vue&type=script&lang=js"
export * from "./AddInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports